import React, { useState, useEffect, useContext } from 'react';
import ProductCard from './ProductCard';
import CircularProgress from '@mui/material/CircularProgress';
import { Card, CardContent, Typography, Button, Box, IconButton } from '@mui/material';

import { Add, Remove } from '@mui/icons-material';
import { collection } from 'firebase/firestore';
import { db } from '../firebase';
import { onSnapshot } from 'firebase/firestore';
import format from 'date-fns/format';
import { CartContext } from '../CartContext';


function TicketsList({ ticketLocation, startDate }) {
  const cart = useContext(CartContext)
  startDate = startDate ?? new Date();
  const dayOfTheWeek = format(startDate, 'EEEE');
  const startDateFormatted = format(startDate, 'yyyy-MM-dd')
  const [tickets, setTickets] = useState([]);

  useEffect(() => {
    if(!ticketLocation) return;

    const unsub = onSnapshot(
    collection(db, `tickets`), (snapshot) => {
      const ticketDocs = snapshot.docs;
      const filteredTickets = ticketDocs.flatMap((doc) => {
        const data = doc.data();
        if (
          (ticketLocation && ticketLocation !== data.location) ||
          data.isDisabled ||
          // displayed on certain days unless there's an overwrite
          (
            data.enabledDays && !data.enabledDays.includes(dayOfTheWeek)
            && !(data.enabledDates?.length && data.enabledDates.find(d =>
              new Date(d.from).setHours(0, 0, 0, 0) <= startDate.getTime() &&
              new Date(d.to).setHours(0, 0, 0, 0) >= startDate.getTime()
            ))
          ) ||
          // hidden on certain date ranges
          (data.disabledDates?.length && data.disabledDates.find(d =>
            new Date(d.from).setHours(0, 0, 0, 0) <= startDate.getTime() &&
            new Date(d.to).setHours(0, 0, 0, 0) >= startDate.getTime()
          ))
        )
          return []

        return [{ ...data, id: doc.id }]
      })
      setTickets(filteredTickets)

      // Add the first ticket to the cart if it's empty
      if (filteredTickets.length > 0 && cart.items.length === 0) {
        cart.addOneToCart(filteredTickets[0])
      }
    })

    return () => {
      unsub();
    }

  }, [ticketLocation]);


  return (
    <div>
      {tickets.length === 0 ? (
        <Box sx={{ display: 'flex', p: 2, justifyContent: 'center' }}>
          <CircularProgress />
        </Box>
      ) : (
        <div>
          {tickets.map((ticket, index) => (
            <div key={index}>
              <ProductCard product={ticket} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default TicketsList;
